import model from "./errorModel.json";
import { cellCovariates, rainInterval } from "./errorModel.js";
import { latLonToCell } from "./grid.js";

const MS_PER_HOUR = 3600 * 1000;

// The model is calibrated on held-out events without radar gaps; with gaps
// the radar misses rain and the range is too narrow (68% vs 90% coverage).
export function rangeMayBeNarrow(result) {
  return (result?.runCov?.gapFraction || 0) > 0;
}

function cellAt(result, lat, lon) {
  const { col, row } = latLonToCell(result.grid, lat, lon);
  const c = Math.round(col);
  const r = Math.round(row);
  if (c < 0 || r < 0 || c >= result.grid.nx || r >= result.grid.ny) return null;
  return cellCovariates({ total: result.total, grid: result.grid, col: c, row: r });
}

// 90% range { q05, q50, q95, ... } for the gauge-scale total at (lat, lon)
// over the whole window, or null outside coverage / without run covariates.
export function intervalAt(result, lat, lon) {
  if (!result?.runCov) return null;
  const cell = cellAt(result, lat, lon);
  if (!cell || !Number.isFinite(cell.totalMm)) return null;
  return rainInterval(model, { ...result.runCov, ...cell });
}

// Low/high bounds along a running-total series: at each sample the window is
// the time elapsed since the start (at least the model's 1 h minimum).
export function cumulativeBand(result, lat, lon, cum) {
  if (!result?.runCov) return null;
  const cell = cellAt(result, lat, lon);
  if (!cell) return null;
  const lo = new Array(cum.t.length);
  const hi = new Array(cum.t.length);
  for (let k = 0; k < cum.t.length; k++) {
    const v = cum.v[k];
    if (!Number.isFinite(v)) {
      lo[k] = NaN;
      hi[k] = NaN;
      continue;
    }
    const windowHours = Math.max(1, (cum.t[k] - result.startMs) / MS_PER_HOUR);
    const iv = rainInterval(model, { ...result.runCov, ...cell, totalMm: v, windowHours });
    lo[k] = iv.q05;
    hi[k] = iv.q95;
  }
  return { lo, hi };
}
